import { render, staticRenderFns } from "./AIcon.vue?vue&type=template&id=15553776"
import script from "./AIcon.vue?vue&type=script&lang=ts"
export * from "./AIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports